import React from 'react';
import S3Image from '../../../helpers/S3Image';

const ImageMessage = props => {
  return <S3Image s3Key={props.message} style={{ width: 300, height: 300 }} />;
};

export default ImageMessage;

// <img
// className="sc-support-message--file"
// src={API('post', 's3_access_url', { urls: props.message }).then(
//     response => response.accessUrl
// )}
// alt={'Chat'}
// />
